<template>
    <!-- Auth redesign — 404 в split-оболочке (макет Claude Design «404 Not Found»).
         Контент по левому краю (как .form в макете), центрируется только строка под кнопкой. -->
    <AuthShell :brand="this.brand" :trust="this.trustItems">
        <template #lang><LangSwitcher /></template>
        <template #brand-logo><BrandLogo /></template>

        <div class="auth-form is-result">
            <div class="e404-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>
            </div>
            <div class="form-head">
                <span class="big-404">404</span>
                <h1 class="form-title" style="font-size: 26px">{{ $t('views.Unexpected.1') }}</h1>
                <p class="form-sub">{{ $t('views.Unexpected.2') }}</p>
            </div>
            <a href="/" class="e404-btn">{{ $t('views.Unexpected.3') }}</a>
            <div class="form-foot">{{ $t('views.Unexpected.5') }} <a href="/reg" class="accent-link">{{ $t('views.Unexpected.4') }}</a></div>
        </div>
    </AuthShell>
</template>

<script>
import AuthShell from '@/components/service/AuthShell';
import LangSwitcher from '@/components/service/LangSwitcher';
import BrandLogo from '@/components/service/BrandLogo';

export default {
    components: { AuthShell, LangSwitcher, BrandLogo },
    computed: {
        brand() {
            return {
                eyebrow: this.$t('views.Unexpected.6'),
                headline: this.$t('views.Unexpected.7'),
                lead: this.$t('views.Unexpected.8'),
            };
        },
        trustItems() {
            return [
                this.$t('views.Login.75'),
                this.$t('views.Login.76'),
                this.$t('views.Login.77'),
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
// иконка-плитка — акцентная (фиолетовая), по левому краю (макет .sent-icon.is-error)
// иконка-плитка по центру
.e404-icon {
    width: 72px; height: 72px; border-radius: 18px; margin: 0 auto 22px;
    display: grid; place-items: center;
    background: var(--accent-surface); color: var(--accent-link);
}
.e404-icon svg { width: 38px; height: 38px; }

// крупное «404» с градиентной заливкой текста; вес 900 + системный шрифт (тяжелее, чем фиксированный HelveticaNeue bold)
.big-404 {
    display: block;
    font-family: 'HelveticaNeue bold', 'Roboto bold', sans-serif;
    font-size: 72px; font-weight: 800; letter-spacing: -0.05em; line-height: 1; margin: 0 0 14px;
    background: linear-gradient(135deg, var(--accent), color-mix(in srgb, var(--accent) 55%, #000));
    -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}

.e404-btn {
    height: 52px; width: 100%; border-radius: var(--radius-field);
    display: inline-flex; align-items: center; justify-content: center;
    background: var(--accent); color: var(--accent-text); font-size: 15.5px; font-weight: 600; text-decoration: none;
    box-shadow: 0 8px 20px -8px color-mix(in srgb, var(--accent) 65%, transparent);
    transition: background .15s ease, box-shadow .15s ease;
}
.e404-btn:hover { background: var(--accent-press); }
</style>
